export default "__VITE_ASSET__Cz4yi5rM__"